import axios from 'axios'

export type AwardScholarshipBody = {
  distribution_strategy: 'single'
  program_purse_id: number
  program_id: number
}

export type DistributionPreviewParams = {
  distribution_strategy: 'single'
  program_id: number
  program_purse_id: number
}

export async function USE_WITH_CAUTION_AWARD_SCHOLARSHIPS({
  program_purse_id,
  program_id,
}: Omit<AwardScholarshipBody, 'distribution_strategy'>) {
  const payload: AwardScholarshipBody = {
    distribution_strategy: 'single',
    program_purse_id,
    program_id,
  }

  const response = await axios.post(`/scholarships/distribution`, payload)
  return response.data
}

export async function getDistributionPlanPreview({
  program_purse_id,
  program_id,
  distribution_strategy = 'single',
}: DistributionPreviewParams) {
  const response = await axios.get(`/scholarships/distribution/plan_preview`, {
    params: {
      distribution_strategy,
      program_id,
      program_purse_id,
    },
  })
  return response.data
}
